module.exports = (parcelRequire.load("gLLj0")).then(() => parcelRequire('3C8sv'));